export default "__VITE_ASSET__DHMD9fFs__"